module.exports = __webpack_public_path__ + "static/img/team-rule.2877913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdAnniversary/popup/team-rule.png
// module id = PN30
// module chunks = 2